import { t as tr } from './i18n.js'
import { useState } from 'react'
import { Bell } from 'lucide-react'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { Link } from 'react-router'
import { api, type Notification } from './api.js'
import { fmt } from './pages/Account.js'

export function NotificationsBell() {
  const qc = useQueryClient()
  const q = useQuery({ queryKey: ['notifications'], queryFn: () => api<{ notifications: Notification[]; unread: number }>('/notifications?limit=20'), refetchInterval: 60_000 })
  const [open, setOpen] = useState(false)
  const read = useMutation({ mutationFn: (ids?: number[]) => api('/notifications/read', { method: 'POST', json: ids ? { ids } : {} }), onSuccess: () => qc.invalidateQueries({ queryKey: ['notifications'] }) })
  const unread = q.data?.unread ?? 0
  return (
    <div className="timerwidget">
      <button className="link bell" onClick={() => setOpen((o) => !o)} aria-label={`${unread} unread notifications`} data-tip={tr("Notifications")}><Bell size={16} strokeWidth={2} aria-hidden />{unread > 0 && <span className="badge">{unread}</span>}</button>
      {open && (
        <div className="timerpop" style={{ width: '24rem' }}>
          <div className="row between"><strong>{tr("Notifications")}</strong>{unread > 0 && <button className="link small" onClick={() => read.mutate(undefined)}>Mark all read</button>}</div>
          {(q.data?.notifications ?? []).length === 0 && <p className="muted small">{tr("Nothing yet.")}</p>}
          {(q.data?.notifications ?? []).map((n) => (
            <div key={n.id} className={`notif ${n.readAt ? '' : 'unread'}`} onClick={() => { if (!n.readAt) read.mutate([n.id]) }}>
              <div>{n.link ? <Link to={n.link} onClick={() => setOpen(false)}>{n.title}</Link> : n.title}</div>
              {n.body && <div className="small muted">{n.body}</div>}
              <div className="small muted">{fmt(n.createdAt)}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
